import { render, staticRenderFns } from "./SingleTravelFeatureModal.vue?vue&type=template&id=35abc37a&scoped=true&"
import script from "./SingleTravelFeatureModal.vue?vue&type=script&lang=ts&"
export * from "./SingleTravelFeatureModal.vue?vue&type=script&lang=ts&"
import style0 from "./SingleTravelFeatureModal.vue?vue&type=style&index=0&id=35abc37a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35abc37a",
  null
  
)

export default component.exports